<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-title>Input</v-card-title>
          <ValidationObserver ref="form" v-slot="{ invalid }" immediate>
            <v-form v-model="valid">
              <v-container>
                <v-row dense>
                  <v-col cols="2">
                    <v-btn
                      text
                      color="primary"
                      href="sample_files/dummy_enz_act_prediction.tsv"
                    >
                      Search file sample
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      text
                      color="primary"
                      href="sample_files/dummy_enz_act_reference.tsv"
                    >
                      Reference file sample
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="Search file"
                      rules="required"
                    >
                      <v-file-input
                        label="Search file"
                        v-model="searchFile"
                        :error-messages="errors"
                        :success="valid">
                      </v-file-input>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      label="Reference file"
                      v-model="referenceFile"
                      :error-messages="errors"
                      :success="valid">
                    </v-file-input>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="n_neighbors"
                      rules="required|integer"
                    >
                      <v-text-field
                        label="n_neighbors"
                        v-model="nNeighbors"
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="min_dist"
                      rules="required|min_value:0"
                    >
                      <v-text-field
                        label="min_dist"
                        v-model="minDist"
                        type="number"
                        step="0.01"
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="metric"
                      rules="required"
                    >
                      <v-select
                        label="metric"
                        v-model="selectMetric"
                        :items="metrics"
                        :error-messages="errors"
                        :success="valid"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions class="d-flex justify-end">
                <v-btn @click="upload" :disabled="invalid">submit</v-btn>
                <v-btn @click="clear">clear</v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import axios from 'axios';
import router from "../router";

let instance = null;

export default {
  data: () => ({
    valid: true,
    referenceFile: null,
    searchFile: null,
    nNeighbors: 5,
    minDist: 0.1,
    metrics: [
      'euclidean',
      'cosine',
      'correlation',
    ],
    selectMetric: null,
  }),
  mounted: function() {
    this.checkLoggedIn();
  },
  methods: {
    ...mapActions("util", ["showProgress", "hideProgress", "openSnackbar", "closeSnackbar", ]),
    // ログインチェック
    checkLoggedIn: function() {
      this.$session.start();
      if (this.$session.has("token")) {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        instance = axios.create({
          headers: {
            Authorization: "JWT " + this.$session.get('token'),
          }
        })
      } else {
        router.push("/login");
      }
    },
    // 入力クリア
    clear: function() {
      this.referenceFile = null;
      this.searchFile = null;
      this.nNeighbors = 5;
      this.minDist = 0.1;
      this.selectMetric = null;
    },
    // ファイルアップロード
    upload: function() {
      this.showProgress();

      const formData = new FormData();
      formData.append('user', this.$store.state.userName);
      formData.append('referenceFile', this.referenceFile);
      formData.append('searchFile', this.searchFile);
      formData.append('nNeighbors', this.nNeighbors);
      formData.append('minDist', this.minDist);
      formData.append('metric', this.selectMetric);

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        }
      }

      const url = '/api/upload_activity/';
      instance.post(url, formData, config).then((response) => {
        if (response.status === 200) {
          this.hideProgress();
          this.btnDisabled = false;
          this.openSnackbar({ text:'File was uploaded. Please check the result on Result Inquiry screen.', color:'success' });
        } else {
          this.hideProgress();
          this.openSnackbar({ text:'File upload failed.', color:'error' });
        }
      }).catch(() => {
        this.hideProgress();
        this.openSnackbar({ text:'File upload failed.', color:'error' });
      });
    },
  }
};
</script>
